import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import store from './store';

// --------------- Helpers --------------------------

const formatDataObject = (props_js) => {
	let data = {};
	let status = "none";
	if ( typeof props_js === 'object' && props_js !== null ) {
		if ( Object.keys(props_js) !== undefined ) {
			if ( Object.keys(props_js).length > 0 ) {
				data = {...props_js};
				status = "available";
			}
		}
	}
	data = {...data};
	return [data,status];
}

// --------------------------------------------------


const fetchData = createAsyncThunk(
	'dataStates/fetchData',
	async (props) => {

		// props {
		// id: this will be the reference name of the data returned to place in the store
		// script_uri: the php to call
		// (optional) data_js: stored in the $_POST["data"]; php must convert it with json_decode
		// }

		store.dispatch({
			type: "dataStates/setupDataState",
			payload: { id: props.id }
		});

		let formData = new FormData();

		if ( props.data_js === undefined ) {
			formData.append("init",null);
		} else {
			Object.keys(props.data_js).forEach( k => formData.append(k,props.data_js[k]) );
		}

		let script_uri = store.getState().serverState.uri + props.script_uri;

		const request = new Request(
			script_uri ,
			{
				method: 'POST',
				body: formData
			}
		);

		let payload;
		var fetch_res, fetch_res_js;
		try {

			fetch_res = await fetch(request);

			store.dispatch({
				type: "dataStates/updateDataState",
				payload: { 
					id: props.id,
					status: "fetching"
				}
			});

			fetch_res_js = await fetch_res.json();

			payload = {
				id: props.id,
				props_js: fetch_res_js
			}

		} catch (e) {

			payload = {
				id: props.id,
				props_js: {}
			}

			store.dispatch({
				type: "dataStates/updateDataState",
				payload: { 
					id: props.id,
					status: "err"
				}
			});

		}

		// This returns to the extra reducers:
		// fetchDataThunk.fulfilled
		return payload;
	}
);

export const dataStates = createSlice({
	
	name: "dataStates",

	initialState: {
		// This should have an id key and and {} with props
		data: {
			login: {
			  status: 'available',
			  data: {
				token: '186741044163119',
				result: true,
				feedback: '<span style="color:#0D0DFF">ID and password are correct!</span>',
				data_js: {
				  date: '2022-05-14 17:46:52',
				  uid: 'jgc',
				  app: 'none',
				  period: 'Spring 2022',
				  name_uid: 'Joe Collentine',
				  name_app: 'none',
				  apps_js: {
					por212: 'POR 212 - Second year Portuguese',
					spaling: 'SPA 340/341 - Ling&uuml;&iacute;stica espa&ntilde;ola',
					por112: 'POR 112 - First year Portuguese'
				  },
				  langs_apps_js: {
					por112: 'portuguese',
					por212: 'portuguese',
					spaling: 'spanish'
				  }
				}
			  }
			}
		  }
	},

	// to send data to these:
	// use useDispatch()
	// or
	// store.dispatch({type: "myName/myReducer",payload: {...}}); 

	reducers: {

		setupDataState: (state, action) => {

			
			let js = action.payload;

			let id =js.id;

			state.data[id] = undefined;
			
			let props_js = {
				status: ['err','none','initialized','fetching','available'][1],
				data: {}
			}
			state.data[id] = props_js;

		},

		updateStatusState: (state, action) => {
			let js = action.payload;

			let id =js.id;
			let status = action.payload.status;

			state.data[id].status = status

		},

		updateDataState: (state, action) => {
			let js = action.payload;

			let id =js.id;
			
			if ( state.data.hasOwnProperty(id) ) {
				let props_js = js.props_js;
				
				const [ data, status ] = formatDataObject(props_js);
				let current_props = {...state.data[id].data};
				state.data[id].data = {
					...current_props,
					...data
				}
				state.data[id].status = status;
			}
		},

		updateAppNameState: (state, action) => {
			let js = action.payload;
			const { app, name_app } = js;
			state.data.login.data.data_js.app = app;
			state.data.login.data.data_js.name_app = name_app;
		},

		setDataIDTokensCue: (state, action) => {
			let js = action.payload;
			
			let res_js;

			try {
				if ( Object.keys(js.data_id_tokens_cue_js).length === 0 ) {
					// The tokens cue is empty
					res_js = {};
				} else {
					// There are k:v combos, in the form of
					// id: token
					// So, we reverse them so that the key/lookup
					// is the token.
					// E.g.,
					// {app_data: '848604289850658', uid_data: '690913454380750'} >
					// { '848604289850658': { id: 'app_data', status: 'fetching' }, 
					//   '690913454380750': { id: 'uid_data', status: 'fetching' } }
					res_js = {};
					Object.keys(js.data_id_tokens_cue_js).forEach( (k) => {
						let v = js.data_id_tokens_cue_js[k];
						res_js[v] = {id: k, status: 'fetching'};
					});
				}
				state.data.data_id_tokens_cue_js = res_js;
			} catch(e) {
				state.data.data_id_tokens_cue_js = Object.assign(
					{}, state.data.data_id_tokens_cue_js
				);
			}

			

		},
		updateDataIDTokenStatus: (state,action) => {
			let js = action.payload;

			let token = js.token;
			let status = js.status;

			try {
				state.data.data_id_tokens_cue_js[token].status = status;

			} catch(e) {
				//a=1
			}
		},
		
	},


	
	extraReducers: {
		[fetchData.fulfilled]: (state, action) => {
			let js = action.payload;
	
			let id =js.id;
			let props_js = js.props_js;

			const [ data, status ] = formatDataObject(props_js);

			state.data[id].data = data;
			state.data[id].status = status;

			let p = {
				token:data.token,
				status:status
			}
			dataStates.caseReducers.updateDataIDTokenStatus(state,{payload: p });
		}
	}

});

// Exports

// Dispatchers

export {
	fetchData
};

export const {
	setDataIDTokensCue,
	updateAppNameState
} = dataStates.actions;

// Selectors

// useSelector( getServerState ) subscribes to this:
// useSelector( (state) => getServerState(state, args**) ) subscribes to this:



export const getDataStates = (state) => {
	return state.dataStates.data;
}

// const id_data = useSelector( (state) => getDataById(state, myid) )
export const getDataById = (state, id) => {
	let d;
	try {
		d = state.dataStates.data[id].data;
	} catch (e) {
		d = "none";
	}
	return d;
}

export const getCurrentApp = (state) => {
	let current_app;
	try {
		current_app = state.dataStates.data.login.data.data_js.app;
	} catch (e) {
		current_app = "none";
	}
	return current_app;
}

export const getFetchDataStatusById = (state, id) => {
	let st;
	try {
		st = state.dataStates.data[id].status;
	} catch (e) {
		st = "none";
	}
	return st;
}

export const countAvailableStatusByIdArray = (state, id_a) => {

	let res;
	let n;

	try {
		n = 0;
	
		id_a.forEach( (id) => {
			try {
				if ( state.dataStates.data[id].status === 'available' ) {
					n++;
				}
			} catch(e) {
				n=n+0;
			}
	
		});
	
		if ( n === id_a.length ) {
			res = true;
		} else {
			res = false;
		}
	} catch(e) {
		res = false;
	}

	return res;
	
}

export const getDataIDTokensCue = (state) => {

	let res;

	try {
		res = state.dataStates.data.data_id_tokens_cue_js;
	} catch(e) {
		res = {};
	}

	return res;

}

export default dataStates.reducer;
